const API_URL = process.env.REACT_APP_STAGE === 'production'
  ? 'https://prdapi.gogochart.com/api'
  : process.env.REACT_APP_STAGE === 'development' || process.env.REACT_APP_STAGE === 'local-y' || process.env.REACT_APP_STAGE === 'dev-zay' || process.env.REACT_APP_STAGE === 'dev-wesley' || process.env.REACT_APP_STAGE === 'fake' || process.env.REACT_APP_STAGE === 'aliyun-dev'
  ? 'https://devapi.gogochart.com/api'
  : 'http://localhost:3003/api';

console.log(' env ', process.env)
console.log ( ' payment : ', API_URL);
export default API_URL;


// WEBPACK FOOTER //
// ./src/constants/server.js